<bz-dialog-layout [heading]="heading | translate" [dismissible]="true">

  <form bzDialogContent class="terms-editor-form layout-column gap-10" [formGroup]="form">

    <bz-form-field [label]="'Policy Title' | translate"
                   [required]="true"
                   [error]="form.controls.title.touched && form.controls.title.invalid ? ('Policy title is required' | translate) : ''">
      <bz-input formControlName="title"
                [placeholder]="'Policy Title' | translate"
                [readonly]="isReadOnly"
                [invalid]="form.controls.title.touched && form.controls.title.invalid">
      </bz-input>
    </bz-form-field>

    <!-- Not a bz-form-field: it wraps its content in a <label>, and a click inside a <label> is
         re-dispatched to the first form control in it - Quill's hidden toolbar <select> - which
         Quill reads as a click outside its pickers and closes them as soon as they open. -->
    <div class="terms-editor-field">
      <span class="terms-editor-field__label">
        {{ 'Policy Content' | translate }}<span class="terms-editor-field__required" aria-hidden="true">*</span>
      </span>
      <quill-editor class="terms-editor"
                    formControlName="content"
                    format="html"
                    theme="snow"
                    [modules]="editorModules"
                    [formats]="editorFormats"
                    [readOnly]="isReadOnly"
                    [placeholder]="'Policy Content' | translate">
      </quill-editor>
      @if (form.controls.content.touched && form.controls.content.invalid) {
        <p class="terms-editor-field__error" role="alert">{{ 'Policy content is required' | translate }}</p>
      }
    </div>

  </form>

  <div bzDialogActions class="layout-row layout-align-space-between-center flex">
    <bringoz-button type="tertiary" (onClick)="onCancel()">
      <span>{{ (isReadOnly ? 'Close' : 'Cancel') | translate }}</span>
    </bringoz-button>
    @if (!isReadOnly) {
      <bringoz-button theme="secondary" [isDisabled]="isSaving" (onClick)="onSubmit()">
        <span>{{ (data.version ? 'Update' : 'Create') | translate }}</span>
      </bringoz-button>
    }
  </div>

</bz-dialog-layout>
